import { ShowQueueRecordsStore } from '../../../../application/store';
import React from 'react';
export const MakeShowQueueRecordsStore = () => {
  return new ShowQueueRecordsStore();
};
